import React from "react";
import "./PrivacyPolicyHeader.css";

const PrivacyPolicyHeader = () => {
  return (
    <section className="PrivacyPolicyHeader-container">
      <div className="PrivacyPolicyHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="PrivacyPolicyHeader-title">Our Privacy Policy</h1>
          <div className="PrivacyPolicyHeader-breadcrumb">
            <button className="btn btn-primary">Home - Privacy Policy</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyHeader;
